import { Helmet } from 'react-helmet-async';
import React from "react";

const hasValues = (data) => (
  data &&
  typeof data === 'object' &&
  Object.values(data).some((value) => {
    if (value === null || value === undefined) return false;
    if (Array.isArray(value)) return value.length > 0;
    return String(value).trim() !== '';
  })
);

const SEO = ({ seoData, initialSeo, globalSchema }) => {
  const seo = seoData || initialSeo || {};
  const schema = globalSchema || {};

  if (!hasValues(seo) && !hasValues(schema)) {
    return null;
  }

  const title = seo.title || seo.og_title || seo.twitter_title || '';
  const description = seo.description || seo.og_description || seo.twitter_description || '';
  const canonicalUrl = seo.canonical_tag || seo.og_url || seo.url || '';
  const ogTitle = seo.og_title || title;
  const ogDescription = seo.og_description || description;
  const twitterTitle = seo.twitter_title || title;
  const twitterDescription = seo.twitter_description || description;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      {description && <meta name="description" content={description} />}
      {seo.url && <meta property="url" content={seo.url} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta property="og:locale" content={seo.og_locale || 'en_IN'} />
      <meta property="og:type" content={seo.og_type || 'website'} />
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {schema.og_site_name && <meta property="og:site_name" content={schema.og_site_name} />}
      {seo.og_image && <meta property="og:image" content={seo.og_image} />}

      <meta name="twitter:card" content={schema.twitter_card || 'summary_large_image'} />
      {schema.twitter_site && <meta name="twitter:site" content={schema.twitter_site} />}
      {twitterTitle && <meta name="twitter:title" content={twitterTitle} />}
      {twitterDescription && <meta name="twitter:description" content={twitterDescription} />}
      {seo.twitter_image && <meta name="twitter:image" content={seo.twitter_image} />}
      {schema.twitter_creator && <meta name="twitter:creator" content={schema.twitter_creator} />}

      {seo.faq_schema && <script type="application/ld+json">{seo.faq_schema}</script>}
      {seo.article_schema && <script type="application/ld+json">{seo.article_schema}</script>}
      {(Array.isArray(seo.additional_schemas) ? seo.additional_schemas : [])
        .filter((item) => item?.schema)
        .map((item, index) => (
          <script
            key={`${item.label || 'additional-schema'}-${index}`}
            type="application/ld+json"
            data-schema-label={item.label || undefined}
          >
            {item.schema}
          </script>
        ))}
      {schema.review_schema && <script type="application/ld+json">{schema.review_schema}</script>}
      {schema.organisation_schema && (
        <script type="application/ld+json">{schema.organisation_schema}</script>
      )}
      {(Array.isArray(schema.additional_schemas) ? schema.additional_schemas : [])
        .filter((item) => item?.schema)
        .map((item, index) => (
          <script
            key={`global-${item.label || 'additional-schema'}-${index}`}
            type="application/ld+json"
            data-schema-label={item.label || undefined}
            data-schema-scope="global"
          >
            {item.schema}
          </script>
        ))}
    </Helmet>
  );
};

export default SEO;
